import Cookies from 'js-cookie'

const TokenKey = 'Admin-Token'
const ExpiresKey = 'Token-Expires-In'
const ExpiresDateKey = 'Date-Expires-In'
const RefreshTokenKey = 'Refresh-Token'
const RefreshTokenExpires = 'Refresh-Token-Expires-In'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, `Bearer ${token}`)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function setAuthData({ accessToken, refreshToken, expiresIn, refreshExpiresIn }) {
  Cookies.set(TokenKey, `Bearer ${accessToken}`)
  Cookies.set(ExpiresKey, expiresIn)
  Cookies.set(ExpiresDateKey, getExpiresInDate(expiresIn))
  Cookies.set(RefreshTokenKey, refreshToken)
  Cookies.set(RefreshTokenExpires, refreshExpiresIn)
}

export function getAuthData() {
  return {
    accessToken: Cookies.get(TokenKey),
    refreshToken: Cookies.get(RefreshTokenKey),
    expiresIn: Cookies.get(ExpiresKey),
    expiresInDate: Cookies.get(ExpiresDateKey),
    refreshExpiresIn: Cookies.get(RefreshTokenExpires)
  }
}

export function removeAuthData() {
  Cookies.remove(TokenKey)
  Cookies.remove(ExpiresKey)
  Cookies.remove(ExpiresDateKey)
  Cookies.remove(RefreshTokenKey)
  Cookies.remove(RefreshTokenExpires)
}

function getExpiresInDate(expiresIn) {
  const nowMs = +new Date()
  const expiresMs = nowMs + expiresIn * 1000
  return +new Date(expiresMs)
}
